
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import PlatformMarkerSubmergedBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerSubmergedBarrel";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import PlatformMarkerJungleLogLong from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogLong";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckStartChunk extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 465, y ?? 365);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -182, 300);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 762, 300);
    this.add(editor_bounds_right);

    // platformSubmergedBarrel
    const platformSubmergedBarrel = new PlatformMarkerSubmergedBarrel(scene, 488, 271);
    this.add(platformSubmergedBarrel);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 510, -34);
    this.add(gemMarker);

    // platformMarkerLogLong
    const platformMarkerLogLong = new PlatformMarkerJungleLogLong(scene, 283, 31);
    this.add(platformMarkerLogLong);

    // decorationFloatingPoleLong
    const decorationFloatingPoleLong = new DecorationFloatingPoleLong(scene, -45, 168);
    this.add(decorationFloatingPoleLong);

    // decorationFloatingPoleLong_1
    const decorationFloatingPoleLong_1 = new DecorationFloatingPoleLong(scene, 279, 164);
    this.add(decorationFloatingPoleLong_1);

    // decorationFloatingPoleLong_2
    const decorationFloatingPoleLong_2 = new DecorationFloatingPoleLong(scene, 685, 171);
    this.add(decorationFloatingPoleLong_2);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 21, 11);
    this.add(checkpointMarker);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
